var $body = document.body,
  $targets = [...document.querySelectorAll('[data-effect]')],
  vh = window.innerHeight * 0.01,
  callback = (entries, observer) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('-active');
      observer.unobserve(entry.target);
    });
  },
  option = {
    // root: null,
    rootMargin: '-25% 0%',
    // threshold: 0,
  },
  observer = new IntersectionObserver(callback, option);

// body にカスタム変数（--vh）を設定
$body.style.setProperty('--vh', `${vh}px`);

// 読込完了後に表示クラスを追加
window.addEventListener('load', () => $body.classList.add('-show'));

// スクロールする際にターゲットの要素を監視
$targets.forEach($target => observer.observe($target));